import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'umi';
import { Button, DatePicker, Radio } from 'kenshin';
import TablePro from '@/components/TablePro';
import moment from 'moment';
import { exportRptWorkDetail } from '@/_serveice/dataAnalyse';
import { downloadXlsx } from '@/_util/util';

const { RangePicker } = DatePicker;

const ProjectReportDetail = (props) => {
  const {
    dispatch,
    dataAnalyse: { rptWorkDetailList },
    systemOrgani: { employeeAll, departmentList },
  } = props;

  const tableRef = useRef();
  const curParams = useRef({});
  // 默认为年
  const [dateType, setDateType] = useState('year');
  // 默认当前年份范围（今年到今年）
  const [currentDate, setCurrentDate] = useState([moment(), moment()]);

  // 初始化获取员工列表和部门列表
  useEffect(() => {
    dispatch({
      type: 'systemOrgani/getAllEmployee',
      payload: {},
    });
    dispatch({
      type: 'systemOrgani/getDepartmentPagelist',
      payload: {},
    });
  }, []);

  // 根据日期类型和当前日期计算开始和结束时间
  const getDateRange = (type, date) => {
    let start, end;
    if (!date || !date[0] || !date[1]) {
      // 默认情况，防止空值
      return { statBeginTime: '', statEndTime: '' };
    }

    if (type === 'year') {
      start = date[0].clone().startOf('year').format('YYYY-MM-DD');
      end = date[1].clone().endOf('year').format('YYYY-MM-DD');
    } else if (type === 'month') {
      start = date[0].clone().startOf('month').format('YYYY-MM-DD');
      end = date[1].clone().endOf('month').format('YYYY-MM-DD');
    } else {
      // 日
      start = date[0].format('YYYY-MM-DD');
      end = date[1].format('YYYY-MM-DD');
    }
    return { statBeginTime: start, statEndTime: end };
  };

  // 搜索列配置
  const searchCloumns = [
    {
      name: 'projectName',
      type: 'Input',
      props: {
        placeholder: '输入项目名称模糊查询',
      },
    },
    {
      name: 'deptIds',
      type: 'DeptSelect', // 使用DeptSelect组件
      props: {
        placeholder: '选择部门',
        treeCheckable: true,
        showCheckedStrategy: 'SHOW_PARENT',
        allowClear: true,
      },
    },
    {
      name: 'empIds',
      type: 'Select',
      props: {
        placeholder: '输入员工名称查询',
        mode: 'multiple',
        options: employeeAll,
        allowClear: true,
        filterOption: (input, option) =>
          option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0,
      },
    },
  ];

  // 表格列配置
  const columns = [
    {
      title: '项目名称',
      dataIndex: 'projectName',
      key: 'projectName',
      width: 150,
    },
    {
      title: '部门',
      dataIndex: 'empDept',
      key: 'empDept',
      width: 150,
    },
    {
      title: '岗位',
      dataIndex: 'empJob',
      key: 'empJob',
      width: 120,
    },
    {
      title: '员工姓名',
      dataIndex: 'empName',
      key: 'empName',
      width: 100,
    },
    {
      title: '工作包',
      dataIndex: 'firstServCatgName',
      key: 'firstServCatgName',
      width: 150,
    },
    {
      title: '二级工作包',
      dataIndex: 'secondServCatgName',
      key: 'secondServCatgName',
      width: 150,
    },
    {
      title: '三级工作包',
      dataIndex: 'thirdServCatgName',
      key: 'thirdServCatgName',
      width: 150,
    },
    {
      title: '任务名称',
      dataIndex: 'taskName',
      key: 'taskName',
      width: 150,
    },
    {
      title: '标签',
      dataIndex: 'tagName',
      key: 'tagName',
      width: 120,
    },
    {
      title: '上报日期',
      dataIndex: 'rptDate',
      key: 'rptDate',
      width: 120,
    },
    {
      title: '上报备注',
      dataIndex: 'rptRemark',
      key: 'rptRemark',
      width: 200,
    },
    {
      title: '上报标准工时',
      dataIndex: 'rptWorkHours',
      key: 'rptWorkHours',
      width: 120,
    },
    {
      title: '上报加班工时',
      dataIndex: 'rptWorkOvertimeHours',
      key: 'rptWorkOvertimeHours',
      width: 120,
    },
    {
      title: '上报总工时',
      dataIndex: 'rptTotalHours',
      key: 'rptTotalHours',
      width: 120,
      render: (_, record) => {
        return (
          Number(record.rptWorkHours || 0) +
          Number(record.rptWorkOvertimeHours || 0)
        ).toFixed(1);
      },
    },
    {
      title: '上报审核结果',
      dataIndex: 'rptAuditStatusName',
      key: 'rptAuditStatusName',
      width: 120,
    },
  ];

  // 处理搜索提交
  const onSubmit = (values) => {
    const { statBeginTime, statEndTime } = getDateRange(dateType, currentDate);
    let params = {
      ...values,
      statBeginTime,
      empIds: values.empIds?.map((key) => key.split('-')[1]),
      statEndTime,
      // deptIds和empIds如果是数组，TablePro可能会自动处理，如果接口需要逗号分隔字符串，需要在这里转换
      // deptIds: values.deptIds ? values.deptIds : undefined,
      // empIds: values.empIds ? values.empIds : undefined,
    };
    curParams.current = { ...params };
    return params;
  };

  // 导出
  const handleExport = () => {
    const params = curParams.current;

    downloadXlsx(exportRptWorkDetail, '项目上报明细', 'post', params);
  };

  const extra = () => [
    <Button key="export" type="primary" onClick={handleExport}>
      导出
    </Button>,
  ];

  // 顶部日期切换区域
  const renderDateFilter = () => (
    <div style={{ marginBottom: 16 }}>
      <Radio.Group
        value={dateType}
        onChange={(e) => {
          setDateType(e.target.value);
          // 切换类型时，重置为当前时间范围
          setCurrentDate([moment(), moment()]);
        }}
        buttonStyle="solid"
      >
        <Radio.Button value="day">日</Radio.Button>
        <Radio.Button value="month">月</Radio.Button>
        <Radio.Button value="year">年</Radio.Button>
      </Radio.Group>
      <div style={{ marginTop: 16 }}>
        <span style={{ marginRight: 8 }}>日期范围:</span>
        <RangePicker
          picker={dateType === 'day' ? 'date' : dateType}
          value={currentDate}
          onChange={(val) => {
            if (val) setCurrentDate(val);
          }}
          allowClear={false}
        />
      </div>
    </div>
  );

  return (
    <div style={{ padding: 20, background: '#fff' }}>
      {renderDateFilter()}
      <TablePro
        actionRef={(ref) => (tableRef.current = ref)}
        request="dataAnalyse/getRptWorkDetailList"
        data={rptWorkDetailList}
        columns={columns}
        searchCloumns={searchCloumns}
        onSubmit={onSubmit}
        extra={extra}
        scrollX
        curColumns
        rowKey={(record, index) => index}
      />
    </div>
  );
};

export default connect(({ dataAnalyse, systemOrgani }) => ({
  dataAnalyse,
  systemOrgani,
}))(ProjectReportDetail);
